export const RISK_TEST_ADD = 'RISK_TEST_ADD';
